import React, { useRef } from 'react';
import BaseFilter, { BaseFilterParams } from './BaseFilter';
import { SelectV2Option } from '../../selectV2/types';
import { useFilterContext } from '../FilterV2Context';
import SelectV2 from '../../selectV2/SelectV2';

export type SelectFilterProps = BaseFilterParams & {
    options: SelectV2Option[];
    values: SelectV2Option[];
};

/**
 * Filter option that contains a undetermined list of values.
 *
 * *Use Case*: Filtering a list of values from a dynamic source. e.g. api
 *
 * *Example*: Worksheet assigned.
 *
 * **NOTE** Load the options outside of the filter component.
 *
 * @param props SelectFilterProps
 */
function SelectFilter({ id, label, options, values: _values }: SelectFilterProps): JSX.Element {
    const ctx = useFilterContext();
    const { values } = ctx.getDraft(id, 'select');
    const ref = useRef<HTMLDivElement | null>(null);

    return (
        <BaseFilter id={id} label={label} activeCount={values.length} key={id} onMenuClose={console.log}>
            <div className="p-2 min-w-[300px] max-w-[450px]" ref={ref}>
                <SelectV2
                    autoFocus
                    options={options}
                    size="small"
                    value={values}
                    onChange={(v): void => ctx.updateValues('select', id, { values: v })}
                    isMulti
                    root={ref}
                />
            </div>
        </BaseFilter>
    );
}

export default SelectFilter;
